// @flow
import React from 'react'
import type {Node} from 'react'
import classNames from 'classnames'

import {type Alert} from 'components/types'
import styles from './index.scss'

type Props = {
  alert: ?Alert,
  children: Node,
  className: ?string,
  feedback: ?string,
  id?: ?string,
  label: ?Node,
  rightButton: ?Node,
  hideRightButton: boolean,
  small: boolean,
  medium: boolean,
  target: string,
  topRightAnnotation?: ?Node,
}

function FormGroup(props: Props): Node {
  const alert = props.alert ? props.alert : {message: props.feedback, severity: null}
  const formClassName = classNames(styles.formGroup, props.className, {
    [styles.formGroupSmall]: props.small,
    [styles.formGroupMedium]: props.medium,
    'has-danger': alert.severity === 'ERROR',
    'has-warning': alert.severity === 'WARNING',
    'has-success': alert.severity === 'SUCCESS',
    'form-group': true,
  })

  return (
    <div id={props.id} className={formClassName}>
      {props.label && (
        <label className="form-label form-control-label" htmlFor={props.target}>
          {props.label}
        </label>
      )}
      {props.topRightAnnotation}
      <div className={styles.input}>
        {props.children}
        {!props.hideRightButton && (
          <div className={styles.rightPart}>
            {props.rightButton}
          </div>
        )}
      </div>
      <div className={styles.labels}>
        {alert.message && (
          <div className="form-control-feedback">{alert.message}</div>
        )}
      </div>
    </div>
  )
}

FormGroup.defaultProps = {
  alert: null,
  className: null,
  feedback: null,
  id: null,
  label: null,
  rightButton: null,
  small: false,
  medium: false,
  hideRightButton: false,
}

export default FormGroup
